import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../language/keys';
import { WIDGET_COLORS } from '../consts';
import { BubbleChart } from './bubble-chart/bubble-chart.component';
import { IndustryList } from './industry-list/industry-list.component';

import {
  Container,
  Label,
  Title,
  MarkedTitle,
} from './experience-by-industry-widget.styled';

const MAX_INDUSTRIES_TO_SHOW = 5;

type ExperienceBreakdownProps = {
    experienceList: ExperienceByIndustryData[],
}

export const ExperienceByIndustry = ({
  experienceList,
}:ExperienceBreakdownProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const chartData:ExperienceByIndustryChart[] = experienceList
    .slice()
    .sort((a, b) => b.tenureInMonths - a.tenureInMonths)
    .slice(0, MAX_INDUSTRIES_TO_SHOW)
    .map((item, index) => {
      return {
        ...item,
        color: WIDGET_COLORS[index % WIDGET_COLORS.length],
      };
    });

  return (
    <Container>
      <Label>{translate(STRING_KEYS.EXPERIENCE_BREAKDOWN)}</Label>
      <Title>
        {translate(STRING_KEYS.EXPERIENCE_BY)}
        <MarkedTitle>
          {translate(STRING_KEYS.INDUSTRY)}
        </MarkedTitle>
      </Title>
      <BubbleChart chartData={ chartData } />
      <IndustryList items={ chartData } />
    </Container>
  );
};
